import { FreshRecipe } from "@api-clients/subscriptions";

export type TTexture = "chunky" | "smooth" | "shredded";

export interface IFreshRecipeDetails {
  name: string;
  description: string;
  imageSrc: string;
  forKittens: boolean;
  texture: TTexture;
  isNewRecipe?: boolean;
}

export type FreshRecipeDetailsMap = Record<FreshRecipe, IFreshRecipeDetails>;

export const IMAGE_BASE_URL = "/images/features/product-overview/packaging/";

export const FRESH_RECIPE_DETAILS: FreshRecipeDetailsMap = {
  CLUCK: {
    name: "CLUCK",
    description: "Fresh, 100% gently-cooked chicken thigh, liver and heart.",
    imageSrc: "cluck_2025.webp",
    forKittens: true,
    texture: "chunky",
  },
  GOBBLE: {
    name: "GOBBLE",
    description: "Fresh, 100% gently-cooked turkey thigh, liver and chicken thigh and gizzards.",
    imageSrc: "gobble_2026.webp",
    forKittens: true,
    texture: "chunky",
  },
  QUACK: {
    name: "QUACK",
    description: "Fresh, 100% gently-cooked chicken heart, thigh, liver and duck gizzards.",
    imageSrc: "quack_2025.webp",
    forKittens: true,
    texture: "chunky",
  },
  MOOO: {
    name: "MOOO",
    description: "Fresh, 100% gently-cooked beef trim, heart and liver.",
    imageSrc: "mooo_2026.webp",
    forKittens: true,
    texture: "chunky",
  },
  OINK: {
    name: "OINK",
    description: "Fresh, 100% gently-cooked pork shoulder, trim and liver.",
    imageSrc: "oink_2025.webp",
    forKittens: true,
    texture: "chunky",
  },
  BAAA: {
    name: "BAAA",
    description: "Fresh, 100% gently-cooked lamb heart, trim, liver and kidney.",
    imageSrc: "baaa_2025.webp",
    forKittens: false,
    texture: "chunky",
  },
  SWISH: {
    name: "SWISH",
    description: "Fresh, 100% gently-cooked tuna, salmon, chicken heart and liver.",
    imageSrc: "swish_2026.webp",
    forKittens: true,
    texture: "chunky",
  },
  SPLASH: {
    name: "SPLASH",
    description: "Fresh, 100% gently-cooked whitefish, salmon and turkey liver.",
    imageSrc: "splash_2025.webp",
    forKittens: true,
    texture: "chunky",
  },
  SHREDDED_CLUCK: {
    name: "CLUCK (SHREDDED)",
    description: "Fresh, 100% gently-cooked shredded chicken thigh, liver and heart.",
    imageSrc: "shredded-cluck.webp",
    forKittens: true,
    texture: "shredded",
    isNewRecipe: true,
  },
  SHREDDED_GOBBLE: {
    name: "GOBBLE (SHREDDED)",
    description: "Fresh, 100% gently-cooked shredded turkey thigh, liver and chicken thigh, gizzards.",
    imageSrc: "shredded-gobble.webp",
    forKittens: true,
    texture: "shredded",
    isNewRecipe: true,
  },
  SMOOTH_CLUCK: {
    name: "CLUCK (SMOOTH)",
    description: "Fresh, 100% gently-cooked chicken thigh, liver and heart.",
    imageSrc: "smooth_cluck_2026.webp",
    forKittens: true,
    texture: "smooth",
    isNewRecipe: true,
  },
  SMOOTH_PECK: {
    name: "PECK (SMOOTH)",
    description: "Fresh, 100% gently-cooked chicken liver and heart, turkey thigh and duck gizzards.",
    imageSrc: "smooth_peck_2026.webp",
    forKittens: true,
    texture: "smooth",
    isNewRecipe: true,
  },
};

export const getFreshRecipeDisplayName = (recipe: string, fallbackName?: string): string => (
  FRESH_RECIPE_DETAILS[recipe as FreshRecipe]?.name ?? fallbackName ?? recipe
);
